import { Button } from '@mantine/core';
import { AiOutlinePlus } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

export const AddButton = () => {
    const navigate = useNavigate();

    return (
        <Button
            leftSection={<AiOutlinePlus size={16} />}
            onClick={() => navigate('/billing/payment-method-setup')}
        >
            Add Payment Method
        </Button>
    );
};
